import { images } from '../services/images.service'

export function RedDivider() {
  return (
    <div className='w-full my-20'>
      <img className='w-full' src={images.redDivider} alt="Divider" />
    </div>
  )
}
